/** @jsx h */
/** @jsxFrag Fragment */
import { ComponentProps, h } from "preact";
import { DatStyleOpts, DatStyleOptsDefaults, DatStyleOptsToStyle } from "./uiParams.tsx";
import { useDatStyle } from "./useDatStyle.tsx";

export const folderClosed = `data:image/gif;base64,R0lGODlhBQAFAJEAAP////Pz8////////yH5BAEAAAIALAAAAAAFAAUAAAIIlGIWqMCbWAEAOw==`;
export const folderOpened = `data:image/gif;base64,R0lGODlhBQAFAJEAAP////Pz8////////yH5BAEAAAIALAAAAAAFAAUAAAIIlI+hKgFxoCgAOw==`;

export type DatArrowProps = {
  arrowDir: "up" | "down";
} & ComponentProps<"div">;
export function DatArrow(props: DatArrowProps) {
  const { arrowDir: dir, ...rest } = props;
  return (
    <div
      style={{
        width: 10,
        height: 20,
        background: `rgba(0, 0, 0, 0) url(${
          props.arrowDir === "up" ? folderOpened : folderClosed
        }) 0 48% no-repeat`,
      }}
      {...rest}
    ></div>
  );
}

export interface DatUIBaseProps {
  class?: any;
  style?: any;
  label?: string;
  onChange?: (value: any) => void;
}

export interface DatGuiProps {
  style?: any;
  class?: any;
  children: any;
  styleOpts?: Partial<DatStyleOpts>;
}
export function DatGui(props: DatGuiProps) {
  useDatStyle();
  const styleOpts = { ...DatStyleOptsDefaults, ...props.styleOpts };

  return (
    <div class="react-dat-gui" style={props.style}>
      <style>{DatStyleOptsToStyle(styleOpts)}</style>
      <ul class="dg main">{props.children}</ul>
    </div>
  );
}
